import { collection, query, where, getDocs, getDoc, setDoc, addDoc, updateDoc, deleteDoc, doc, writeBatch, Timestamp } from 'firebase/firestore';

import { firestoredb, storage } from './firebaseProject';

const getSubcollection = async (doc) => {
  let data = doc.data();
  for (let key in data) {
    const item = data[key];
    if (typeof item === 'object' && item && item.parent) {
      await db(item.parent.id).get(item.id, async (itemData) => {
        data[key] = itemData;
      });
    }
  }

  return { id: doc.id, ...data };
};

const listElements = (queryResult) => {
  const elements = queryResult.docs.map(async (doc, _) => {
    return await getSubcollection(doc);
  });

  return Promise.all(elements);
};

const db = (collectionName) => {
  const dbRef = collection(firestoredb, collectionName);
  return {
    storage: () => storage.ref(),
    collectionRef: () => dbRef,
    docRef: (id) => doc(dbRef, id),
    count: (onResult, onError = (_) => {}) =>
      getDocs(dbRef)
        .then((documentSnapshot) => {
          onResult(documentSnapshot.size);
        })
        .catch(onError),
    all: (onResult, onError = (_) => {}) => {
      getDocs(dbRef)
        .then(async (queryResult) =>{
          onResult(await listElements(queryResult))
        })
        .catch(onError)
    },
    get: (id, onResult, onError = (_) => {}) =>
      getDoc(doc(dbRef, id))
        .then(async (documentSnapshot) => {
          onResult(await getSubcollection(documentSnapshot));
        })
        .catch(onError),
    where: (fieldPath, opStr, value, onResult, onError = (_) => {}) => {
      const q = query(dbRef, where(fieldPath, opStr, value));
      getDocs(q)
        .then(async queryResult => onResult(await listElements(queryResult)))
        .catch(onError);
    },
    set: (id, data, onSuccess, onError = (_) => {}) => {
      const timeStamp = Timestamp.now();
      setDoc(doc(dbRef, id),
        { createdAt: timeStamp, updatedAt: timeStamp, ...data })
        .then(onSuccess)
        .catch(onError);
    },
    add: (data, onSuccess, onError = (_) => {}) => {
      const timeStamp = Timestamp.now();
      addDoc(dbRef,{
        createdAt: timeStamp,
        updatedAt: timeStamp,
        ...data,
        isActive: true
      })
        .then(onSuccess)
        .catch(onError);
    },
    update: (id, data, onSuccess, onError = (_) => {}) => {
      const timeStamp = Timestamp.now();
      updateDoc(doc(dbRef, id), {
        updatedAt: timeStamp,
        ...data
      })
        .then(onSuccess)
        .catch(onError);
    },
    active: (id, onSuccess = (_) => {}, onError = (_) => {}) => {
      const timeStamp = Timestamp.now();
      updateDoc(doc(dbRef, id), {
        updatedAt: timeStamp,
        isActive: true
      })
        .then(onSuccess)
        .catch(onError);
    },
    close: (id, onSuccess = (_) => {}, onError = (_) => {}) => {
      const timeStamp = Timestamp.now();
      updateDoc(doc(dbRef, id), {
        updatedAt: timeStamp,
        isActive: false
      })
        .then(onSuccess)
        .catch(onError);
    },
    delete: (id, onSuccess = (_) => {}, onError = (_) => {}) =>
      deleteDoc(doc(dbRef, id)).then(onSuccess).catch(onError),
    destroyBatch: (ids, notify) => {
      let batch = writeBatch(firestoredb);
      ids.forEach((id) => {
        batch.delete(doc(dbRef, id));
      });
      batch
        .commit()
        .then(function () {
          console.log(`${collectionName} entries successfully deleted!`);
          notify('warning', `${collectionName} entries successfully deleted!`);
        })
        .catch(function (error) {
          console.error(`Error removing ${collectionName} entries: `, error);
          notify('error', `Error removing ${collectionName} entries: ` + error);
        });
    }
  };
};

export default db;
